import * as types from '../mutation-types'
import { services } from '../api'

const state = {
  main: {}
}

const mutations = {
  [types.FILE_UPLOAD] (state, files) {
    state.main = files
  }
}
const actions = {
  fileUpload ({ commit }, data) {
    // API request
    return services.files.upload(data)
    .then((response) => {
      console.log(response)
      commit(types.FILE_UPLOAD, response.data)
    })
    .catch((error) => {
      console.error(error)
    })
  }
}

export default {
  state,
  mutations,
  actions
}
